module.exports = __webpack_public_path__ + "img/not-found.bc4a7b7b.svg";